import { render, staticRenderFns } from "./modal_account_post.vue?vue&type=template&id=5abd5129&scoped=true"
import script from "./modal_account_post.vue?vue&type=script&lang=js"
export * from "./modal_account_post.vue?vue&type=script&lang=js"
import style0 from "./modal_account_post.vue?vue&type=style&index=0&id=5abd5129&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abd5129",
  null
  
)

export default component.exports